module.exports = __webpack_public_path__ + "b2c3e05b3a7fbd9b35e1b323f2178e49.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/campaign_fr.mp4
// module id = 940
// module chunks = 4